import { useContext, useRef } from "react";
import { SidebarContext } from "core/contexts/sidebar/sidebar";

export default function SideBarToolTip({children, parent, isIcon}) {
  const { setSidesideBarItemPositionTop, setShowHideTooltip, setSidebarParentNode, sidebarParentNode } = useContext(SidebarContext);
  const targetRef = useRef<HTMLElement | null>(null);
  
  // Handle mouse enter and leave events to show/hide the tooltip
  const handleMouseEnter = () => {
    if (targetRef.current) {
      const targetRect = targetRef.current.getBoundingClientRect();
      setSidesideBarItemPositionTop(targetRect.top);
      setShowHideTooltip(true);
      setSidebarParentNode(parent);
    }
  };
  
  // The tooltip is currently disabled, removal is a backlog item
  return (
    <span 
      className={`d-flex align-items-center sidebar-text`}
      // ref={targetRef}
      // onMouseEnter={handleMouseEnter}
    >
      {children}
    </span>
  );
}
